export const GENERATE_IDEA = 'GENERATE_IDEA'
export const GENERATE_IDEA_SUCCESS = 'GENERATE_IDEA_SUCCESS'